export const currencySigns = {
  USD: '$',
  EUR: '€',
};
